<template>
    <div class="mb-3" v-if="slotGames >= 1">
        <h2>{{ title }}</h2>

        <div v-if="isLoading" class="m-5">
            <div
                class="spinner-grow text-secondary tex"
                role="status"
                style="margin: 0 auto; float: none; display: block"
            >
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="automation-progressive-jackpot progressive-jackpots row mr-0" v-else>
            <div
                v-for="slotGame in slotGames"
                v-bind:key="slotGame.id"
                class="col-6 col-md-3 pr-0 mb-3"
                :class="slotGame.jackpot_id"
            >
                <div class="card overflow-hidden">
                    <picture>
                        <source media="(max-width:320px)" :data-srcset="slotGame.images.thumb"/>
                        <source
                            media="(max-width:321px) and (max-width:479px)"
                            :data-srcset="slotGame.images.medium"
                        />
                        <source
                            media="(min-width:480px) and (max-width:767px)"
                            :data-srcset="slotGame.images.main"
                        />
                        <source
                            media="(min-width:768px) and (max-width:991px)"
                            :data-srcset="slotGame.images.medium"
                        />
                        <source media="(min-width:992px)" :data-srcset="slotGame.images.main"/>
                        <img
                            class="grid-thumb img-fluid lazyload"
                            :data-src="slotGame.images.main"
                            :alt="slotGame.title"
                        />
                    </picture>
                    <div class="price">
                        {{ currencyFormatter.format(slotGame.jackpot_amount) }}
                    </div>
                    <div class="card-body p-2">
                        <div class="automation-title title">
                            <span>{{ slotGame.title }}</span>
                        </div>
                        <div class="row m-0">
                            <a
                                class="col-lg-6 p-0 exit-link button-blue text-uppercase"
                                :href="slotGame.exit_link"
                            >
                                {{ exitLinkText }}
                            </a>
                            <a
                                class="automation-read-review review-link col-lg-6 p-0 d-flex justify-content-end align-self-center"
                                :href="slotGame.review_link"
                            >
                                {{ reviewLinkText }} &#187;
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.getJackpots();
    },
    props: {
        title: String,
        slotGames: Array,
        exitLinkText: String,
        reviewLinkText: String,
        lang: String,
        currency: String,
    },
    data() {
        return {
            jackpotsApiURI:
                'https://i8fnuae28h.execute-api.eu-west-1.amazonaws.com/production/progressive-slots/progressive-game-jackpots.json',
            isLoading: true,
            currencyFormatter: new Intl.NumberFormat(this.lang, {
                style: 'currency',
                currency: this.currency,
                minimumFractionDigits: 2,
            }),
        };
    },
    methods: {
        getJackpots() {
            let that = this;
            fetch(this.jackpotsApiURI)
                .then((response) => response.json())
                .then((jackpotsData) => {
                    that.slotGames.map(function (slotGame) {
                        // if the endpoint does not return all game ids back
                        slotGame.jackpot_amount = 0;
                        if (jackpotsData[slotGame.id]) {
                            slotGame.jackpot_amount = jackpotsData[slotGame.id][that.currency];
                        }
                    });

                    // filter the games without a jackpot amount (if the endpoint dit not include them)
                    // $productFeatureIds = [319, 38, 525, 696, 31, 464, 434, 2097];
                    that.slotGames = that.slotGames.filter(function (slotGame) {
                        return slotGame.jackpot_amount > 0;
                    });

                    that.isLoading = false;
                });
        },
    },
};
</script>
